import {axiosGetAuthorize, axiosPostAuthorize} from '../AxiosRequests';
import {DeleteInquiryResponse,GetInquiryResponseById,GetInquiryResponseList,SendInquiryResponseEmails,GetInquiryProductDetailByEmailId} from '../ApiEndPoints';

export default class InquiryResponseServices {

        //** Call API : */
        async deleteInquiryResponse(request){
            return axiosPostAuthorize(DeleteInquiryResponse, request);
        }

        async getInquiryResponseById(request){
            return axiosGetAuthorize(GetInquiryResponseById, request);
        }

        async getInquiryResponseList(request){
            return axiosPostAuthorize(GetInquiryResponseList, request);
        }

        async sendInquiryResponseEmails(request){
            return axiosPostAuthorize(SendInquiryResponseEmails, request);
        }

        async getInquiryProductDetailByEmailId(request){
            return axiosGetAuthorize(GetInquiryProductDetailByEmailId, request);
        }
        
}